import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus } from "lucide-react";
import { toast } from "sonner";

export default function Returns() {
  const [items, setItems] = useState([]);
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ order_id: "", reason: "", photo_urls: [] });
  const load = async () => { const { data } = await api.get("/dealer/returns"); setItems(data); };
  useEffect(() => {
    load();
    api.get("/dealer/orders", { params: { status: "DELIVERED" } }).then(({ data }) => setOrders(data));
  }, []);
  const save = async () => {
    try { await api.post("/dealer/returns", form); toast.success("Return request raised"); setOpen(false); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="dealer-returns">
      <div className="flex items-start justify-between">
        <div><h1 className="font-display text-2xl sm:text-3xl font-black">Returns & claims</h1><p className="text-muted-foreground">Damage, replacement and warranty requests.</p></div>
        <Button onClick={() => setOpen(true)} data-testid="return-create-btn"><Plus className="w-4 h-4 mr-1" /> New return</Button>
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Order</TableHead><TableHead>Reason</TableHead><TableHead>Status</TableHead><TableHead>Created</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((r) => (
              <TableRow key={r.id} data-testid={`return-${r.id}`}>
                <TableCell className="font-mono text-xs">{r.order_number}</TableCell>
                <TableCell className="text-sm">{r.reason}</TableCell>
                <TableCell><Badge>{r.status}</Badge></TableCell>
                <TableCell className="font-mono text-[10px]">{new Date(r.created_at).toLocaleString()}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground py-10">No return requests yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Raise return request</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Order (delivered only)</Label>
              <Select value={form.order_id} onValueChange={(v) => setForm({ ...form, order_id: v })}>
                <SelectTrigger data-testid="return-order"><SelectValue placeholder="Pick order…" /></SelectTrigger>
                <SelectContent>{orders.map((o) => <SelectItem key={o.id} value={o.id}>{o.number} · ₹{o.total.toLocaleString()}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label>Reason</Label><Input value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} placeholder="Damage / wrong product / warranty…" data-testid="return-reason" /></div>
            <div className="text-xs text-muted-foreground">Photo upload coming next iteration — for now, attach links to your reason text.</div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={save} disabled={!form.order_id || !form.reason} data-testid="return-save">Submit</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
